import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LoginFormComponent } from '@assist/account-widgets';
import { translation } from '@cue/translations';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'assist-multiview-renew-more',
  imports: [LoginFormComponent, TranslocoPipe],
  templateUrl: './multiview-renew-more.component.html',
  styleUrl: './multiview-renew-more.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiviewRenewMoreComponent {
  qrCodeId = input<string>();
  resourceId = input<string>();
  qrQueryParam = input<'multiview' | 'multiviewQr'>('multiview');
  dashboardMultiViewUrl = computed(() => {
    const resourceId = this.resourceId();
    if (resourceId) {
      return `/dashboard?multiviewResource=${encodeURIComponent(resourceId)}`;
    }
    const qrCodeId = this.qrCodeId();
    if (qrCodeId) {
      return `/dashboard?${this.qrQueryParam()}=${encodeURIComponent(qrCodeId)}`;
    }
    return '/dashboard';
  });
  protected readonly translation = translation;
}
